import gql from "graphql-tag";


export const UpdateScheduleItemResult = gql`
  mutation UpdateScheduleItemResult($input: UpdateScheduleItemResultInput!) {
    updateScheduleItemResult(input: $input) {
      id
      result
    }
  }
`;


export const UpdateScheduleItemRobot = gql`
  mutation UpdateScheduleItemRobot($input: UpdateScheduleItemRobotInput!) {
    updateScheduleItemRobot(input: $input) {
      id
      robotName
    }
  }
`;



// WEBPACK FOOTER //
// ./src/private/common/components/Tournament/TeamCell.graphql.js